function App() {
  return <div>15기 파이팅 💖</div>;
}

export default App;
